import React from 'react';
import ForgotPasswordForm from '../../components/Auth/ForgotPasswordForm';
import PageWrapper from '../../components/PageWrapper';

const ForgotPassword = (props) => {
  return (
    <PageWrapper>
      <div className="container m-auto">
        <div className="row">
          <div className="col-12">
            <ForgotPasswordForm history={props.history} />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default ForgotPassword;
